/**
 * Progressive enhancement for the Vertical Tabs component
 * (Views/Partials/components/verticalTabs.cshtml).
 *
 * The accordion itself is native <details> sharing a `name`, so expanding, collapsing and the
 * one-open-at-a-time rule all work without this file. What it adds is the paired image: opening
 * a panel cross-fades the image alongside it to the matching one.
 */

function initVerticalTabs(root) {
    const items = Array.from(root.querySelectorAll("[data-vertical-tabs-item]"));
    const images = Array.from(root.querySelectorAll("[data-vertical-tabs-image]"));

    if (items.length === 0 || images.length === 0) {
        return;
    }

    // A panel whose tab has no image fades every image out rather than leaving a stale one on
    // screen next to unrelated copy.
    function showImage(index) {
        images.forEach((image) => {
            const active = image.dataset.index === index;

            image.classList.toggle("opacity-100", active);
            image.classList.toggle("opacity-0", !active);
        });
    }

    items.forEach((item) => {
        item.addEventListener("toggle", () => {
            if (!item.open) {
                return;
            }

            // Safety net for browsers that don't yet enforce exclusive <details name="...">.
            // Closing a sibling re-fires toggle, which the guard above drops.
            items.forEach((other) => {
                if (other !== item) {
                    other.open = false;
                }
            });

            showImage(item.dataset.index);
        });
    });
}

document.querySelectorAll("[data-vertical-tabs]").forEach(initVerticalTabs);
